const loadAsset = require('./modules/load-asset');
const easyReveal = require('./modules/easyReveal');

const init = () => {
    //start easy reveal
    easyReveal.init();
    //load fonts
    loadAsset(`./assets/css/fonts.css`, 'link');
    //load google fonts
    loadAsset('https://fonts.googleapis.com/css2?family=Cardo:wght@400;700&display=swap', 'link');
}


if(document.readyState === 'ready' || document.readyState === 'complete') {
    init();
} else {
    document.onreadystatechange = function () {
        if (document.readyState == "complete") {
            init();
        }
    }
}